import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';

interface HomePaneState {
  clientProfileDisplayed: boolean;
  chatsDisplayed: boolean;
  feedbackDisplayed: boolean;
  chatRoomDisplayed: boolean;
  publicUserProfileDisplayed: boolean;
}

const initialState: HomePaneState = {
  clientProfileDisplayed: false,
  chatsDisplayed: false,
  feedbackDisplayed: false,
  chatRoomDisplayed: false,
  publicUserProfileDisplayed: false,
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    toggleChatPanel: (state) => {
      // console.log('TOGGLING CHAT PANEL');
      state.chatsDisplayed = !state.chatsDisplayed;
    },
    toggleClientProfilePanel: (state) => {
      // console.log('TOGGLING PROFILE PANEL');
      state.clientProfileDisplayed = !state.clientProfileDisplayed;
    },
    toggleFeedbackPanel: (state) => {
      // console.log('TOGGLING FEEDBACK PANEL');
      state.feedbackDisplayed = !state.feedbackDisplayed;
    },
    toggleChatRoomPanel: (state) => {
      // Ensure Chat Pane is Open Before Proceeding
      if (!state.chatsDisplayed) {
        state.chatsDisplayed = true;
      }

      // Toggle the Room Panel
      if (!state.chatRoomDisplayed) {
        state.chatRoomDisplayed = true;
      } else {
        state.chatRoomDisplayed = false;
      }
    },
    togglePublicUserProfilePanel: (state) => {
      state.publicUserProfileDisplayed = !state.publicUserProfileDisplayed;
    },
  },
});

export const {
  toggleChatPanel,
  toggleClientProfilePanel,
  toggleFeedbackPanel,
  toggleChatRoomPanel,
  togglePublicUserProfilePanel,
} = homeSlice.actions;
export const getChatsPanelState = (state: RootState) =>
  state.home.chatsDisplayed;
export const getProfilePanelState = (state: RootState) =>
  state.home.clientProfileDisplayed;
export const getChatRoomPanelState = (state: RootState) =>
  state.home.chatRoomDisplayed;
export const getPublicUserProfilePanelState = (state: RootState) =>
  state.home.publicUserProfileDisplayed;
export const getFeedbackPanelState = (state: RootState) =>
  state.home.feedbackDisplayed;
export default homeSlice.reducer;
